module.exports = __webpack_public_path__ + "static/media/pc_cv_active_icon.f485df78.png";